import regex from "./regex";

function convertValue(v) {
  if (typeof v === "string") {
    return parseFloat(v.replace(/,/g, ".").replace(/\s+/g, ""));
  }
  return v;
}

function hasValue(value) {
  return value !== null && value !== undefined && String(value).trim() !== "";
}

export default {
  required: value => hasValue(value) || "Pole je vyžadováno.",

  isValidDecimal: value =>
    !hasValue(value) || regex.decimal.test(String(value)) || /^[0-9]+$/.test(String(value)) || "Pouze číselné hodnoty",

  isValidInteger: value =>
    !hasValue(value) || regex.integer.test(String(value)) || "Pouze číselné hodnoty bez mezer",

  isValidEmail: value =>
    !hasValue(value) || regex.email.test(String(value)) || "Hodnota musí být email",

  isValidDate: value =>
    !hasValue(value) || regex.date.test(String(value)) || "Hodnota musí být datum ve formátu DD. MM. YYYY",

  isValidDialingCode: value =>
    !hasValue(value) || regex.diallingCode.test(String(value)) || "Neplatná předvolba",

  maxValue: (maxValue) => (value) =>
    !hasValue(value) || convertValue(value) <= maxValue || `Maximální hodnota je ${maxValue}`,

  minValue: (minValue) => (value) =>
    !hasValue(value) || convertValue(value) >= minValue || `Minimální hodnota je ${minValue}`,
}